module.exports = __webpack_public_path__ + "img/bigx.74bf53b2.png";